package pl.michal_cyran.brand_hub

import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import com.varabyte.kobweb.silk.theme.colors.palette.background
import com.varabyte.kobweb.silk.theme.colors.palette.color
import pl.michal_cyran.brand_hub.style.CyanColors
import pl.michal_cyran.brand_hub.style.CyanColorsDark
import pl.michal_cyran.brand_hub.style.CyanColorsLight

fun ColorMode.toSitePalette(): CyanColors {
    return when (this) {
        ColorMode.LIGHT -> CyanColorsLight
        ColorMode.DARK -> CyanColorsDark
    }
}

@InitSilk
fun initTheme(ctx: InitSilkContext) {
    ctx.theme.palettes.light.background = Color.rgb(0xFAFAFA)
    ctx.theme.palettes.light.color = Colors.Black
    ctx.theme.palettes.dark.background = Color.rgb(0x06080B)
    ctx.theme.palettes.dark.color = Colors.White
}
